var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLastMiddleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 374,
    height: 374,
    viewBox: "0 0 374 374",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.00000551343,
    y: -0.707101,
    width: 259,
    height: 419,
    rx: 129.5,
    transform: "matrix(-0.707107 -0.707107 0.707118 -0.707096 131.348 426.621)",
    fill: "url(#paint0_linear_4550_71151)",
    stroke: "url(#paint1_linear_4550_71151)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4550_71151",
    x1: -0.785513,
    y1: 3.52024,
    x2: 298.704,
    y2: 410.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55DCEA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#2B74E2",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8796FC",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4550_71151",
    x1: 129.995,
    y1: 101.611,
    x2: 129.999,
    y2: 420,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLastMiddleRight);
export default __webpack_public_path__ + "static/media/ic-last-middle-right.b4b21f6832258bf1fee863fb3b6fb149.svg";
export { ForwardRef as ReactComponent };